const App = (() => {
    const DEFAULTS = {
        /**
         * Base header id
         * @type {string}
         *
         */
        mainHeaderId: "header",
        /**
         * Base header id
         * @type {string}
         *
         */
        headerNavToggleIconClass: "fa-regular fa-chevron-down",
    };

    const StickyHeaderOptions = {
        /**
         * When sticky header used
         * @type {boolean}
         *
         */
        stickyEnabled: true,
        /**
         * Is sticky header enable for mobile screens
         * @type {boolean}
         *
         */
        stickyEnableOnMobile: false,

        /**
         * Starting point of sticky header active
         * @type {int}
         *
         */
        stickyStartAt: 10,
        /**
         * Sticky top position
         * @type {int}
         *
         */
        stickySetTop: 0,

        stickyChangeLogo: false,

        stickyHeaderContainerHeight: 70,
    };

    class App {
        /**
         * App Constructor.
         * @constructor
         * @param {Object} options - The options of expander.
         */
        constructor(options = {}) {
            this.options = App.inject(DEFAULTS, options);

            this.initialize();
        }

        initialize() {
            this.html = document.documentElement;
            this.bindHeader();
            this.bindStickyHeader();
            this.bindSlider();
        }

        bindHeader() {
            this.header = document.getElementById(this.options.mainHeaderId);
            this.headerBodyHeight = document.querySelector(
                this.options.mainHeaderId + " div"
            ).offsetHeight;

            this.baseHeaderEvents();
        }

        baseHeaderEvents() {
            Array.from(this.header.querySelectorAll('a[href="#"]')).forEach(
                (item) => {
                    item.addEventListener("click", (e) => {
                        e.preventDefault();
                    });
                }
            );
            // Append Dropdown Item Toggle Icon
            Array.from(
                this.header.querySelectorAll(
                    ".dropdown-toggle, .dropdown-submenu > a"
                )
            ).forEach((item) => {
                if (window.innerWidth < 992) {
                    item.insertAdjacentHTML(
                        "beforeend",
                        '<i class="' +
                            this.options.headerNavToggleIconClass +
                            '"></i>'
                    );
                }
            });
            Array.from(
                this.header.querySelectorAll(
                    '.dropdown-toggle[href="#"], .dropdown-submenu a[href="#"], .dropdown-toggle:not([href="#"]) .fa-chevron-down, .dropdown-submenu a:not([href="#"]) .fa-chevron-down'
                )
            ).forEach((item) => {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (window.innerWidth < 992) {
                        e.currentTarget.closest("li").classList.toggle("open");

                        // Adjust Header Body Height
                        const height = this.headerBodyHeight;
                        /*$('.header-body').animate({
                                height: ($('.header-nav-menu nav').outerHeight(true) + height) + 10
                            }, 0);*/
                    }
                });
            });
        }

        bindStickyHeader() {
            this.setStickyHeaderOptions();
            this.stickyHeaderEvents();
        }

        stickyHeaderEvents() {
            window.addEventListener("scroll", (_) => this.stickyListener());
        }

        stickyListener() {
            this.isSticky() ? this.onSticky() : this.offSticky();
        }

        onSticky() {
            this.html.classList.add("oly-sticky-active");
            // this.stickyHeader.body.style.position = 'fixed';
            // this.stickyHeader.body.style.top = this.stickyHeaderOptions.stickySetTop + 'px';
            // this.stickyHeader.container.style.height = this.stickyHeaderOptions.stickyHeaderContainerHeight + 'px';
            if (this.checkActive(this.stickyHeaderOptions.stickyChangeLogo)) {
                this.changeLogo(true);
            }
        }

        offSticky() {
            this.changeLogo(false);
            this.html.classList.remove("oly-sticky-active");
            // this.removeInlineHeaderStyles()
        }

        isSticky() {
            return window.scrollY > this.stickyHeaderOptions.stickyStartAt;
        }

        // removeInlineHeaderStyles() {
        //     this.stickyHeader.querySelector('.header-body').style = null;
        //     this.stickyHeader.querySelector('.header-body .header-container').style = null;
        // }

        changeLogo(change = false) {
            const logoWrapper = document.querySelector(".header-logo a");
            if (change) {
                logoWrapper.firstElementChild.style.opacity = 0;
                logoWrapper.firstElementChild.style.display = "none";
                logoWrapper.lastElementChild.style.display = "block";
                logoWrapper.lastElementChild.style.opacity = 1;
            } else {
                logoWrapper.firstElementChild.style = null;
                logoWrapper.lastElementChild.style = null;
            }
        }

        setStickyHeaderOptions() {
            this.stickyHeader = document.querySelector(
                '[data-oly-sticky^="{"]'
            );
            if (this.stickyHeader) {
                this.stickyHeaderOptions = App.inject(
                    StickyHeaderOptions,
                    JSON.parse(
                        this.stickyHeader
                            .getAttribute("data-oly-sticky")
                            .replaceAll("'", '"')
                    )
                );
            }
            // this.stickyHeader.body = this.stickyHeader.querySelector('.header-body');
            // this.stickyHeader.container = this.stickyHeader.querySelector('.header-body .header-container');
        }

        checkActive(bool) {
            return (
                bool === true ||
                bool === "active" ||
                "true" ||
                bool === "active"
            );
        }

        bindSlider() {
            //TODO: add slider script here
        }
        /**
         * Inject options object with defaults.
         * @function
         * @static
         */
        static inject(defaults, options) {
            let results = {};
            for (let key in defaults) {
                if ("undefined" !== typeof options[key])
                    results[key] = options[key];
                else results[key] = defaults[key];
            }
            return results;
        }
    }

    return App;
})();

module.exports = App;

function openMenu() {
    $(".main-slider .slider-cursor").css("z-index", "0");
    $(".nav-wrapper").css("opacity", "1").css("pointer-events", "all");
    if (!$("header").hasClass("homepage")) {
        $(".hamburger-menu .nav .demo .menu-icon span").css(
            "background-color",
            "#fff"
        );
    }
    $("header").addClass("nav-open");
    $(".hamburger-menu").addClass("noFollow");
    $(".hamburger-menu").css("pointer-events", "none");
    // setTimeout(() => {

    let navMainWidth = $(".nav-wrapper .main").outerWidth();

    if (window.innerWidth > 1628 && window.innerWidth < 2000) {
        if (window.innerWidth < 1820) {
            $(".hamburger-menu").css("right", 250);
        } else {
            $(" .hamburger-menu").css("right", 165);
        }
    } else if (window.innerWidth < 1628 && window.innerWidth > 500) {
        $(" .hamburger-menu").css("right", 340);
    } else if (window.innerWidth > 2000) {
        $(" .hamburger-menu").css("right", -130);
    } else {
        $(".hamburger-menu").css("right", navMainWidth - 15);
    }

    if (window.innerWidth > 576) {
        $("header.homepage .hamburger-menu").css("right", 340);
    } else {
        $("header.homepage .hamburger-menu").css("right", navMainWidth - 15);
    }
    $(".nav-wrapper .main").css("transform", "translateX(0%)");
    // if (window.innerWidth > 576) {
    //     $('header .hamburger-menu').css('right', 140);
    // } else {
    //     $('header .hamburger-menu').css('right', 60);
    // }

    $("header").css("pointer-events", "none");
    $(".hamburger-menu").css("pointer-events", "all");
    if (window.innerWidth > 576) {
        $(".hamburger-menu").css("top", 37);
    }
    $(".hamburger-menu").css("z-index", 999999999);

    if (window.innerWidth > 768) {
        // setTimeout(() => {
        // $('.header-logo').css('transition', 'transform 0.3s ease, opacity 0.3s ease');
        if ($("header").hasClass("homepage")) {
            if (window.innerWidth > 768) {
                $(".header-logo")
                    .css("transform", "translateX(-50%)")
                    .css("opacity", "0");
            } else {
                $(".header-logo").css("opacity", "0");
            }
        } else {
            $(".header-logo").css("opacity", "0");
        }
        $(".hamburger-menu .page-title").css(
            "transition",
            "transform 0.3s ease, opacity 0.3s ease"
        );
        if ($("header").hasClass("homepage")) {
            $(".hamburger-menu .page-title")
                .css("transform", "translateX(-50%)")
                .css("opacity", "0")
                .css("transition", ".3s linear");
        } else {
            $(".hamburger-menu .page-title").css("opacity", "0");
        }
        $(".main-slider .button-field").css("opacity", "0");
        $(".main-slider .navigations").css("opacity", "0");
        $(".main-slider .swiper-slide .text-field .text").css({
            transform: "translate(-3%, 3%)",
            opacity: "0",
            transition: ".3s linear",
        });

        // }, 150);
    } else {
        // setTimeout(() => {
        $(".header-logo").css("opacity", "0").css("transition", "none");
        $(".main-slider .button-field").css("opacity", "0");
        $(".main-slider .navigations").css("opacity", "0");
        $(".main-slider .swiper-slide .text-field .text").css({
            transform: "translate(-3%, 3%)",
            opacity: "0",
        });

        // }, 150);
    }

    // }, 400);
}

function closeMenu() {
    $(".nav-wrapper .main").css("transform", "translateX(120%)");
    if (window.innerWidth > 576) {
        $(".hamburger-menu").css("right", 28);
    } else {
        $(".hamburger-menu").css("right", 0);
    }
    if (!$("header").hasClass("homepage")) {
        $(".hamburger-menu .nav .demo .menu-icon span").css(
            "background-color",
            "#000"
        );
    }
    $(".hamburger-menu").css("pointer-events", "all");
    if (window.innerWidth > 576) {
        $(".hamburger-menu").css("top", 37);
    } else {
        $(".hamburger-menu").css("top", 13);
    }
    $(".hamburger-menu").css("z-index", 1);
    $("header").removeClass("nav-open");
    $(".hamburger-menu").removeClass("noFollow");
    // setTimeout(() => {
    $(".nav-wrapper").css("opacity", "0").css("pointer-events", "none");
    $(".header-logo").css("transform", "translateX(0%)").css("opacity", "1");
    $(".main-slider .swiper-slide .text-field .text")
        .css("transform", "translateX(0)")
        .css("opacity", "1")
        .css("transform", "translateY(0)");
    $(".main-slider .button-field").css("opacity", "0");
    $(".main-slider .slider-cursor").css("z-index", "4");
    $("button.nav").css("opacity", 1);
    $(".hamburger-menu .page-title").css("opacity", "1");
    $(".hamburger-menu .page-title")
        .css("transform", "translateX(0%)")
        .css("opacity", "1");
    $(".main-slider .button-field")
        .css("transition", ".35s")
        .css("opacity", "1");
    $(".main-slider .navigations")
        .css("transition", ".35s")
        .css("opacity", "1");
    // }, 400);
}

$("button.nav").click(() => {
    if (!$("header").hasClass("nav-open")) {
        openMenu();
    } else {
        closeMenu();
    }
});

$("nav ul li").hover(function () {
    let navMainText = $(".nav-wrapper .text p");
    let newNavText = $(this).text();
    navMainText.css("opacity", 0).css("transform", "translateX(-20px)");
    setTimeout(() => {
        if ($(this).is(":hover")) {
            navMainText.text(newNavText);
            navMainText.css("opacity", 1).css("transform", "translateX(0px)");
        }
    }, 50);
});

$("nav ul li").mouseleave(function () {
    $(".nav-wrapper .text p")
        .css("opacity", 0)
        .css("transform", "translateX(-20px)");
});

$("nav ul li a").click(function () {
    closeMenu();
    setTimeout(() => {
        location.href = $(this).attr("data-href");
    }, 800);
    $(".menu-icon__cheeckbox").prop("checked", false);
});

$("#job-checkbox").change(function () {
    $(this).closest(".checks").find(".files").stop().slideToggle();
});

let fileLength = 0;
let fileList = [],
    inputFiles;

$("#contact-file").change(function (e) {
    $(".files-wrapper").html("");
    inputFiles = e.target;
    let files = this.files;
    fileList = Array.from(files);
    if (fileLength == 0) {
        for (let i = 0; i < files.length; i++) {
            let filename = files[i].name;
            let fileHTML =
                '<label class="new-button file-item file-item-' +
                i +
                '">' +
                '<div class="top">' +
                '<span id="fileName">' +
                filename.substring(0, 25) +
                '...</span><span class="fileStatus"></span>' +
                "</div>" +
                '<div class="progress-bar">' +
                '<div class="progress"></div>' +
                "</div>" +
                '<a href="javascript:;" class="file-cancel-btn">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<circle cx="12" cy="12" r="12" fill="black"/>' +
                '<path d="M16 8L8 16" stroke="white" stroke-opacity="0.9" stroke-width="1.5"/>' +
                '<path d="M8 8L16 16" stroke="white" stroke-opacity="0.9" stroke-width="1.5"/>' +
                "</svg>" +
                "</a>" +
                "</label>";
            $(".files-wrapper").append(fileHTML);
            let item = $(".file-item-" + i);
            item.addClass("in-progress");
            item.find(".fileStatus").text("0%");
            let itemWidthMax;
            setTimeout(() => {
                item.find(".fileStatus").text("45%");
            }, 100);
            setTimeout(() => {
                item.find(".fileStatus").text("50%");
            }, 800);
            setTimeout(() => {
                item.find(".fileStatus").text("75%");
            }, 1100);
            setTimeout(() => {
                item.find(".fileStatus").text("100%");
            }, 1800);
            setTimeout(() => {
                let itemWidth = item.css("width");

                item.find(".progress-bar").hide();
                item.find(".top").find(".fileStatus").hide();
                item.css("width", "max-content");
                itemWidthMax = item.css("width");
                item.css("width", itemWidth);
                item.removeClass("in-progress").addClass("completed");
            }, 2000);
            setTimeout(() => {
                item.css("width", itemWidthMax)
                    .css("padding-right", "32px")
                    .css("display", "flex")
                    .css("justify-content", "center");
            }, 2100);
        }
    }
});

$(document).on("click", ".file-cancel-btn", function () {
    let itemClass = $(this).closest(".file-item").attr("class").split(/\s+/)[2];
    let itemID = itemClass.substring(itemClass.length - 1);
    $(this).closest(".file-item").css("opacity", "0").remove();
    fileList.splice(itemID, 1);
});

$(".btn-ok").click(function () {
    let msgWrapper = $(".form-success");
    msgWrapper
        .find(".wrapper")
        .css("transform", "translateY(-20px)")
        .css("opacity", 0);
    setTimeout(() => {
        msgWrapper.css("transform", "translateY(100%)").css("opacity", 0);
    }, 400);
});

$("#contact-page .form form").submit(function (e) {
    e.preventDefault();
    let msgWrapper = $(".form-success");
    msgWrapper.css("transform", "translateY(0)").css("opacity", 1);
    setTimeout(() => {
        msgWrapper
            .find(".wrapper")
            .css("transform", "translateY(0px)")
            .css("opacity", 1);
    }, 400);
});

// 1600px altında .header-logo a ml 0 oluyor
if (window.innerWidth < 1600) {
    $(".header-logo a").css("margin-left", "0");
}
